// extracted by mini-css-extract-plugin
module.exports = {"head":"SectionList_head__3C3It"};